<!--
================================================
Vue gérant la vérification du compte après clic sur le lien reçu dans l'email d'inscription
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
    <outdoor-layout-comp>
        <div slot="AppContent">
            <div class="columns mainContainer">

                <div class="column"></div>
                <div class="column is-three-quarters formColumn">

                    <div class="columns">
                        <div class="column"></div>

                        <div class="column is-9 columnContForm">
                            <img src="../assets/img/AppLogo.png" alt="Cronocloud App" width="164" height="29" class="logo">

                            <h1 class="is-size-4">{{ $t("verification") }}</h1>

                        </div>
                        <div class="column"></div>

                    </div>
                </div>
                <div class="column"></div>

            </div>
            <!--<component></component>-->
        </div>
    </outdoor-layout-comp>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->

<script>
    // import {mapState} from 'vuex'
    // @ is an alias to /src
    import OutdoorLayoutComp from "../components/OutdoorLayoutComp";
    import GlobalErrorNotification from "../mixins/GlobalErrorNotificationMixin.js";
    import SentryMixin from "../mixins/SentryMixin.js";
    import VueMetaMixin from "../mixins/VueMetaMixin.js";
    import TrackingMixin from "@/mixins/TrackingMixin";

    export default {
        name: 'VerifyAccountView',
        components: {
            OutdoorLayoutComp,
        },
        mixins: [GlobalErrorNotification, SentryMixin,VueMetaMixin, TrackingMixin],

        data: function () {
            return {
                token: this.$route.params.token, // le token pour activer le compte
            }},
        computed: {

            // computed props for store :
            // ...mapState({
            //
            // })
        },
        //==========================================================
        metaInfo() {
            return this.setMeta(this.$t("metaTitleVerifyAccountView"), this.$t("metaDescDefault"))
        },
        //==========================================================
        methods: {
            /*
               Vérifie la validité du token dans l'url
               */
            checkToken() {
                {
                    let self = this;

                    return self.$http
                        .post(`/public/account/verify`, {
                                token: self.token
                            },
                        )
                        .then(function (response) {
                            if (response.data.message == "account has been verified") {
                                // token ok
                                self.$store.commit('UpdateGlobalNotificationComp', {
                                    'isVisible': true,
                                    'color': 'is-success',
                                    'message': self.$t('LeCompteAEtéVérifié')
                                });
                                self.$mixpanel.track('Account verified')
                                self.ga4GlobalEventTrack('Account verified' , {})


                                // redirection vers timeTracking si auth sinon login
                                if(self.$auth.isAuthenticated()){
                                    self.$router.replace({name: 'timeTracking',
                                        params: {'locale': self.$route.params.locale,
                                            'organization': JSON.parse(self.$cookie.get('auth')).organization // ici récupérer la valeur dans le store fonctionne mal (pb au chargement le store est vide), exceptionnellement on utilise le cookie.
                                    }
                                    })
                                }
                                else{
                                    self.$router.replace({name: 'login',params:  {'locale':self.$route.params.locale}})
                                }

                            }
                        })
                        .catch(function (error) {
                            if(error.response.status == 400 && error.response.data.message == 'account is already verified'){
                                self.$store.commit('UpdateGlobalNotificationComp', {
                                    'isVisible': true,
                                    'color': 'is-warning',
                                    'message': self.$t('LeCompteADéjàEtéValidé')
                                });
                            }
                            else if( // si token manquant ou incorrect
                                error.response.status == 400 &&  error.response.data.message == 'verification token is unknown'
                                || error.response.status == 400 &&  error.response.data.message == 'verification token is missing'
                            ){
                                self.$store.commit('UpdateGlobalNotificationComp', {
                                    'isVisible': true,
                                    'color': 'is-warning',
                                    'message': self.$t('LeLienNestPasValide')
                                });
                            }
                            else{
                                let errorCode = '0021'
                                self.showGlobalErrorNotif(self,errorCode)
                                self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "error in verify account check token query"})
                              self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": "erify account check token query"})
                              self.$sentry.captureMessage(`Error ${errorCode} > error in verify account check token query : ${error}`, 'error')
                            }
                        })
                }
            }

        },
        created: function () {
        },
        mounted: function () {
            this.checkToken()

        },
    }
</script>


<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<style lang="scss">
  /*ATTENTION : css non "scoped" s'applique à tout le html*/

</style>

<style scoped lang="scss">
    @import "../assets/css/globalVar.scss";
    @import "../assets/css/bulmaResponsiveDep.scss";


    .formColumn {
        margin-top: 5rem;
        padding: 3rem 1rem;
        background: #f3f3f3;
        border-radius: 3px;

        .logo {
            margin-bottom: 4rem;
        }

        h1 {
            color: $brandThird;
            /*font-size: 2rem;*/
        }

    }
</style>
